import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from '../services/cookie.service';

export function langInitializer(): Promise<unknown> {
  const translate = inject(TranslateService);
  const cookieService = inject(CookieService);
  const document = inject(DOCUMENT);

  return new Promise<void>((resolve) => {
    const currentLang = resolveCurrentLang(
      cookieService.getCookie('_culturePPCustomersWeb'),
      document.documentElement.lang,
    );

    console.log('translate.use(currentLang) ===>', currentLang);
    translate.use(currentLang).subscribe({
      next() {
        resolve();
      },
    });
  });
}

function resolveCurrentLang(
  cookieLocale: string | null,
  documentLang: string | null,
): string {
  return normalizeLang(cookieLocale) ?? normalizeLang(documentLang) ?? 'ro';
}

function normalizeLang(locale: string | null): string | null {
  const value = locale?.trim();

  if (!value) {
    return null;
  }

  return value.split('-')[0].toLowerCase();
}
